<template>
  <b-container>
    <b-row v-for="row in values" :key="row.field">
      <!-- {{row}} -->
      <b-col
        v-if="row.active == true && row.fieldName != null"
        sm="12"
        md="6"
        lg="8"
      >
        <b-form-group :label="row.fieldName" label-for="fieldName">
          <b-form-textarea
            v-if="row.customField == 1"
            id="fieldName"
            v-model="row.value"
            :placeholder="row.tip"
            :readonly="readonly"
          />
          <b-form-input
            v-if="row.customField == 0"
            id="fieldName"
            v-model="row.value"
            :placeholder="row.tip"
            :readonly="readonly"
          />
          <!-- lista de modelstate -->
          <div
            class="text-danger"
            v-if="hasErros && row.required && row.value == ''"
          >
            {{ "Campo obrigátorio" }}
          </div>
          <!-- <div>{{modelstate}}</div> -->
        </b-form-group>
      </b-col>
    </b-row>
    <!-- <div>{{items}}</div> -->
    <!-- <div>{{modelstate}}</div> -->
  </b-container>
</template>
<script>
import CustomFields from "@/components_rms/trackingShippingCompany/occurrenceType/OccurrenceCustomFields.vue";
export default {
  name: "CustomValueOccurrence",
  props: {
    occurrenceId: Number,
    items: Array,
    readonly: Boolean,
    modelstate: Object
  },
  data() {
    return {
      values: [],
    };
  },
  components: {
    CustomFields,
  },
  computed: {
    hasErros() {
      if (!this.modelstate) return false;
      if (this.modelstate.length == 0) return false;

      let count = 0;
      for (let variable in this.modelstate) {
        count++;
      }
      if (count == 0) return false;

      return true;
    },
  },
  mounted() {
    this.getFields();
  },
  methods: {
    getFields() {
      this.$api
        .get("v1/occurrenceType/customFields/" + this.occurrenceId)
        .then((response) => {
          let model = response.data;
          this.values = model;
          // console.log("model");
          // console.log(model);
          // this.$emit("update:items", model);
          // this.$forceUpdate();
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
  },
  watch: {
    occurrenceId() {
      // console.log("entrou");
      if (this.occurrenceId != 0) {
        this.getFields();
        this.$forceUpdate();
      }
    },
    values() {
      this.$emit("update:items", this.values);
      this.$forceUpdate();
    },
  },
};
</script>
